<div class="modal-header">
    <h5 class="modal-title">{{ data ? 'Prosedür Güncelle' : 'Yeni Prosedür Ekle' }}</h5>
    <button type="button" class="close" (click)="closeModal()">
        <span>&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group mb-2">
            <label>Prosedür Adı</label>
            <input type="text" formControlName="name" class="form-control" />
        </div>

        <div class="row">
            <div class="form-group col-xl-4 col-md-4 col-sm-12">
                <label>Tür</label>
                <select class="form-control" formControlName="kindId">
                    <option *ngFor="let k of kinds" [value]="k.id">{{ k.typeName }}</option>
                </select>
            </div>

            <div class="form-group col-xl-4 col-md-4 col-sm-12">
                <label for="referenceId">Referans</label>
                <ng-select [bindValue]="'id'" formControlName="referenceId">
                    <ng-option *ngFor="let reference of references" [value]="reference.id">
                        {{reference.min + reference.unitTypeName + '-' + reference.max
                        +reference.unitTypeName
                        }}</ng-option>
                </ng-select>
            </div>

            <div class="form-check col-xl-4 col-md-4 col-sm-12 mt-1">
                <input class="form-check-input" type="checkbox" formControlName="status" id="status" />
                <label class="form-check-label" for="status">Aktif</label>
            </div>    
        </div>


        <div class="form-group mb-2">
            <label>Açıklama</label>
            <quill-editor formControlName="description" [modules]="quillConfig"></quill-editor>
        </div>

        <hr />
        
        <h6>Dosyalar</h6>
        <div *ngFor="let file of fileList; let i = index" class="border p-2 mb-2 rounded">
            <div class="row">

                <div class="col-md-2">
                    <input type="checkbox" [checked]="file.isActive" (change)="setSingleActive(i)" id="isActive{{ i }}"
                        class="form-check-input me-1" />
                    <label for="isActive{{ i }}">Aktif</label>
                </div>

                <div class="col-md-3">
                    <label>Form No</label>
                    <input type="text" [(ngModel)]="file.formNo" class="form-control"
                        [ngModelOptions]="{ standalone: true }" />
                </div>

                <!-- <div class="col-md-3">
                    <label>Dosya Seç
                    </label>
                    <input type="file" multiple (change)="onFileSelected($event, i)" class="form-control" />
                    <div *ngIf="file.filePath" class="mt-1 text-muted text-info small">
                        {{ getFileName(file.filePath) }}
                    </div>
                </div> -->

                <div class="form-group col-md-4">
                    <label for="basicInputFile">Dosya Seç</label>
                    <div class="custom-file">
                        <input type="file" class="custom-file-input" id="customFile"
                            (change)="onFileSelected($event, i)" />
                        <label class="custom-file-label" for="customFile"> {{ getFileName(i) || 'Dosya Seç' }}</label>
                    </div>
                </div>

                <div class="col-md-2 d-flex align-items-center justify-content-end">
                    <a [href]="backendUrl + file.filePath" *ngIf="file.filePath && file.id > 0" target="_blank">
                        <i data-feather="download" class="text-info cursor-pointer mr-1"></i>
                    </a>

                    <button type="button" class="btn btn-sm btn-warning" appDelete [id]="file.id"
                        controller="ProcedureFiles" *ngIf="file.id > 0" (callback)="getByIdProcedure(procedure.id)">
                        <i class="fa fa-trash"></i>
                    </button>

                    <button type="button" class="btn btn-sm btn-danger" (click)="removeFileItem(i)" *ngIf="!file.id">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-outline-primary btn-sm mb-2" (click)="addFileItem()">
            + Dosya Ekle
        </button>

        <div class="mt-3 text-end">
            <button type="submit" class="btn btn-success">
                {{ data ? 'Güncelle' : 'Kaydet' }}
            </button>
        </div>
    </form>
</div>